<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title class="ion-text-center">
          <logo-img></logo-img>
        </ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/home"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" size-md="8" size-lg="6" size-xl="4">
            <ion-card class="ion-text-center">
              <ion-card-header>
                <logo-img :withText="true"></logo-img>
              </ion-card-header>
              <ion-card-content>
                <ion-item>
                  <ion-label position="floating">{{ t('LoginPage.loginEmail') }}</ion-label>
                  <ion-input inputmode="email" type="text" v-model="loginEmail" enterkeyhint="next" @keyup.enter="focusInputField(pswInput)"></ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="floating">{{ t('LoginPage.password') }}</ion-label>
                  <ion-input ref="pswInput" type="password" v-model="loginPsw" enterkeyhint="send" @keyup.enter="doLogin(loginEmail, loginPsw)"></ion-input>
                </ion-item>
                <ion-button class="submit-btn" expand="block" @click="doLogin(loginEmail, loginPsw)">
                  {{ t('LoginPage.login') }}
                </ion-button>
                <ion-item lines="none">
                  <ion-label @click="goToRegisterPage()" class="ion-text-start text-btn"><small>{{ t('RegisterPage.registerAccount') }}</small></ion-label>
                  <ion-label @click="goToForgotPasswordPage()" class="ion-text-end text-btn"><small>{{ t('ForgotPasswordPage.forgotPassword') }}</small></ion-label>
                </ion-item>
              </ion-card-content>
            </ion-card>
              <ion-select interface="popover" v-model="locale">
                <ion-select-option value="zh">中文</ion-select-option>
                <ion-select-option value="en">English</ion-select-option>
              </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">

import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonCol, IonRow, IonButtons, IonButton, IonIcon,
        IonCard, IonCardHeader, IonCardContent, IonItem, IonBackButton,
        IonLabel, IonInput, IonSelect, IonSelectOption,
        loadingController, } from '@ionic/vue';
import LogoImg from '@/components/LogoImg.vue';

// icons
import { logIn, close, mail, key, globe, } from 'ionicons/icons';
import { ref } from 'vue';

import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';

// services
import AuthService from '@/services/AuthService';

export default {
  name: 'LoginPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
                IonGrid, IonCol, IonRow, IonButtons, IonButton, IonIcon,
                IonCard, IonCardHeader, IonCardContent, IonItem, IonBackButton,
                IonLabel, IonInput, IonSelect, IonSelectOption, LogoImg, },
  setup() {
    const loginEmail = ref("");
    const loginPsw = ref("");
    const pswInput = ref(null);

    // methods
    const { t, locale } = useI18n();
    const router = useRouter();
    const { presentToast, focusInputField } = utils();

    const doLogin = async (email: string, password: any) => {
      if (email && password) {
        const loading = await loadingController.create({});
        await loading.present();
        try {
          await AuthService.doLogin(email, password);
        } catch (e) {
          presentToast(e.message); // wrong email or wrong password
        }
        loading.dismiss();
      } else {
        presentToast(t("RegisterPage.enterEmailAndPassword"), 3000);
      }
    };
    const goToForgotPasswordPage = () => {
      router.replace('/forgot-password'); // go to forgot password page
    }
    const goToRegisterPage = () => {
      router.replace('/register'); // go to registration page
    }

    return {
      t,

      // icons
      logIn, close, mail, key, globe,
      
      // variables
      locale, loginEmail, loginPsw,
      pswInput,

      // methods
      doLogin, goToForgotPasswordPage, goToRegisterPage, focusInputField,
    }
  },
}
</script>

<style scoped>
  .text-btn {
    cursor: pointer;
  }
  ion-grid {
    height: 100%;
  }
  ion-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  ion-select::part(placeholder),
  ion-select::part(text) {
    flex: 0 0 auto;
  }
</style>